import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeAgo',
  pure: false,
  standalone: true,
})
export class TimeAgoPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: string, timeZone = 'Europe/Berlin'): string {
    const now = new Date();
    const valueDate = new Date(value);

    // Adjust `now` to the specified timezone
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    });
    const nowInTimeZone = new Date(formatter.format(now));
    const valueInTimeZone = new Date(formatter.format(valueDate));

    const difference = nowInTimeZone.getTime() - valueInTimeZone.getTime();

    if (difference < 60000) {
      return this.translateService.instant('time_ago.just_now');
    } else if (difference < 3600000) {
      const minutes = Math.floor(difference / 60000);
      return minutes === 1
        ? this.translateService.instant('time_ago.minute_ago')
        : this.translateService.instant('time_ago.minutes_ago').replace('{0}', minutes.toString());
    } else if (difference < 86400000) {
      const hours = Math.floor(difference / 3600000);
      return hours === 1
        ? this.translateService.instant('time_ago.hour_ago')
        : this.translateService.instant('time_ago.hours_ago').replace('{0}', hours.toString());
    } else {
      const days = Math.floor(difference / 86400000);
      return days === 1
        ? this.translateService.instant('time_ago.day_ago')
        : this.translateService.instant('time_ago.days_ago').replace('{0}', days.toString());
    }
  }
}
